export default class {
    getLength(path) {
        return google.maps.geometry.spherical.computeLength(path);
    }
}